package com.schoolconnect.app.datasource.network.request

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
enum class UsageAdoptionRoleFilter {
    @SerialName("All")
    ALL,
    @SerialName("School Admin")
    SCHOOL_ADMIN,
    @SerialName("Management")
    MANAGEMENT,
    @SerialName("Teacher")
    TEACHER,
    @SerialName("Parent")
    PARENT
}

@Serializable
enum class AdoptionCriteriaType {
    @SerialName("ADOPTION_RATE")
    ADOPTION_RATE
}

@Serializable
enum class PercentageOperator {
    @SerialName("LESS_THAN")
    LESS_THAN,
    @SerialName("GREATER_THAN")
    GREATER_THAN,
    @SerialName("EQUAL_TO")
    EQUAL_TO,
    @SerialName("BETWEEN")
    BETWEEN
}

@Serializable
data class UsageAdoptionReportRequest(
    @SerialName("from_date") val fromDate: String,
    @SerialName("to_date") val toDate: String,
    val role: UsageAdoptionRoleFilter = UsageAdoptionRoleFilter.ALL,
    @SerialName("criteria_type") val criteriaType: AdoptionCriteriaType? = null,
    @SerialName("percentage_operator") val percentageOperator: PercentageOperator? = null,
    @SerialName("percentage_values") val percentageValues: List<Double>? = null,
    val limit: Int = 20,
    val offset: Int = 0
)
